import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { StatementTypeEnum } from '../../models';
import { StatementCategoryModel } from '../../models/StatementCategoryModel';
import { useStores } from '../../stores/Hooks';

export const RegisterRightBlock: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();
		const store = uiState.register;

		function categoriesHelp(el: StatementCategoryModel)
		{
			if (!store.SelectedServiceCategories.has(el.Id)) return "";
			return (
				<span key={el.Id}>
					<br />  – &nbsp;
					{el.OrderText} &nbsp;
					<a href={el.LinkOrder.Href} target="_blank" rel="noopener noreferrer nofollow">{uiState.modal.ParseBR(el.LinkOrder.Name)}</a>
				</span>
			);
		}

		return (
			<div className="about">
				<div className="about-text">
					{(store.StatementType === StatementTypeEnum.NewInformation || store.StatementType === StatementTypeEnum.RemoveInformation) &&
						<p className="mb-0">
							Выберите категорию услуг оператора ЭДО и укажите адрес электронной почты для обратной связи.
							На указанный адрес будет направлено сообщение со ссылкой для продолжения регистрации. <br />
							Ссылка действительна 1 сутки.
						</p>
					}
					{(store.StatementType === StatementTypeEnum.ClarifyInformation && !store.FeedbackEmail.IsConfirmed) &&
						<p className="mb-0">
							Укажите идентификационный номер обращения.
							При необходимости добавьте комментарий до 255 символов.
							Заполните информацию на остальных вкладках сервиса.
						</p>
					}
					{(store.StatementType === StatementTypeEnum.ClarifyInformation && store.FeedbackEmail.IsConfirmed) &&
						<p className="mb-0">
							Укажите идентификационный номер обращения и подтвердите адрес электронной почты для обратной связи.
							На указанный адрес будет направлено сообщение с ссылкой для продолжения работы в сервисе. <br />
							Ссылка действительна 1 сутки.
						</p>
					}
					{(store.StatementType === StatementTypeEnum.RemoveInformation) &&
						<p className="mb-0">
							Укажите в комментариях идентификационный номер обращения,
							дату регистрации обращения и предположительную дату исключения из реестра.
							<br />
							<br />
							Заполните информацию на остальных вкладках сервиса.
						</p>
					}
				</div>
				<div className="about-link" style={{ display: store.SelectedServiceCategories.size === 0 ? 'none' : 'block' }}>
					<p className="mb-0">
						{(store.StatementType !== StatementTypeEnum.RemoveInformation) &&
							<>
								Требования к оператору ЭДО:
							</>
						}
						{(store.StatementType === StatementTypeEnum.RemoveInformation) &&
							<>
								Исключение из Реестра операторов ЭДО:
							</>
						}
						{
							Array.from(dataState.Categories.values()).map(el => categoriesHelp(el))
						}
					</p>
				</div>
			</div>
		);
	}
)
